import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { komodoApi } from "../service/komodoApi";
import { ApiError } from "../service/apiClient";
import styles from "./KomodoSettingsPage.module.scss";
export function KomodoSettingsPage() {
    const [connection, setConnection] = useState(null);
    const [loadError, setLoadError] = useState(null);
    const [url, setUrl] = useState("");
    const [apiKey, setApiKey] = useState("");
    const [apiSecret, setApiSecret] = useState("");
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    useEffect(() => {
        komodoApi
            .getConnection()
            .then((result) => {
            setConnection(result);
            if (result.url) {
                setUrl(result.url);
            }
        })
            .catch((err) => setLoadError(err instanceof ApiError ? err.message : "Kunde inte läsa Komodo-inställningar."));
    }, []);
    async function handleSubmit(event) {
        event.preventDefault();
        setError(null);
        setSuccess(false);
        setSubmitting(true);
        try {
            const result = await komodoApi.upsertConnection({ url, apiKey, apiSecret });
            setConnection(result);
            setApiKey("");
            setApiSecret("");
            setSuccess(true);
        }
        catch (err) {
            setError(err instanceof ApiError ? err.message : "Kunde inte spara Komodo-anslutningen.");
        }
        finally {
            setSubmitting(false);
        }
    }
    return (_jsx("div", { className: styles.page, children: _jsxs("form", { className: styles.card, onSubmit: handleSubmit, children: [_jsx("h1", { children: "Komodo-integration" }), _jsx("p", { className: styles.subtitle, children: "Koppla en Komodo-instans s\u00E5 att Sentinel kan visa n\u00E4r ett system som k\u00F6rs som en Docker-stack har en ny image tillg\u00E4nglig." }), loadError && _jsx("p", { className: styles.error, children: loadError }), connection && (_jsx("p", { className: styles.status, children: connection.isConfigured
                        ? `Konfigurerad mot ${connection.url}${connection.updatedAt ? ` (senast ändrad ${new Date(connection.updatedAt).toLocaleString("sv-SE")})` : ""}.`
                        : "Ingen Komodo-anslutning konfigurerad än." })), _jsxs("label", { children: ["Komodo-URL", _jsx("input", { type: "url", value: url, onChange: (e) => setUrl(e.target.value), placeholder: "https://komodo.example.com:9120", required: true })] }), _jsxs("label", { children: ["API-nyckel", _jsx("input", { type: "password", value: apiKey, onChange: (e) => setApiKey(e.target.value), placeholder: (connection === null || connection === void 0 ? void 0 : connection.isConfigured) ? "Oförändrad om lämnad tom" : "", required: !(connection === null || connection === void 0 ? void 0 : connection.isConfigured), autoComplete: "off" })] }), _jsxs("label", { children: ["API-hemlighet", _jsx("input", { type: "password", value: apiSecret, onChange: (e) => setApiSecret(e.target.value), placeholder: (connection === null || connection === void 0 ? void 0 : connection.isConfigured) ? "Oförändrad om lämnad tom" : "", required: !(connection === null || connection === void 0 ? void 0 : connection.isConfigured), autoComplete: "off" })] }), _jsx("p", { className: styles.hint, children: "Skapas i Komodo under Settings \u2192 Users \u2192 (din anv\u00E4ndare eller en Service User) \u2192 Api Keys. En Service User med l\u00E4sbeh\u00F6righet r\u00E4cker \u2014 Sentinel skriver aldrig till Komodo." }), error && _jsx("p", { className: styles.error, children: error }), success && _jsx("p", { className: styles.success, children: "Anslutningen har sparats." }), _jsx("button", { type: "submit", disabled: submitting, children: submitting ? "Sparar…" : "Spara" })] }) }));
}
